import { render } from "./NotificationDesktop.vue?vue&type=template&id=612f4010"
import script from "./NotificationDesktop.vue?vue&type=script&lang=js"
export * from "./NotificationDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__